module.exports = __webpack_public_path__ + "_/images/apps/app_store/app-collage-bg.png";